webpackJsonp([114276838955818,60335399758886],{

/***/ 115:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Michelle Tilley Photography","description":"Portrait and headshot photography for the San Francisco Bay Area"}}},"layoutContext":{}}

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(219);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(115);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(49);
	var isArguments = __webpack_require__(48);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(58);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(47);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(57);
	
	var _HelmetConstants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(50));
	var shallowEqual = _interopDefault(__webpack_require__(60));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 388:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	  return _react2.default.createElement(
	    'footer',
	    { id: 'footer', style: props.timeout ? { display: 'none' } : {} },
	    _react2.default.createElement(
	      'ul',
	      { className: 'icons' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.facebook.com/michelle.tilley.photography', className: 'icon fa-facebook' },
	          _react2.default.createElement(
	            'span',
	            { className: 'label' },
	            'Facebook'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'https://instagram.com/tilley.photos/', className: 'icon fa-instagram' },
	          _react2.default.createElement(
	            'span',
	            { className: 'label' },
	            'Instagram'
	          )
	        )
	      )
	    )
	  );
	};
	
	Footer.propTypes = {
	  timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Middot = _react2.default.createElement(
	    'span',
	    { style: { color: '#999' } },
	    '\xB7',
	    _react2.default.createElement('wbr', null)
	);
	
	var Header = function Header(props) {
	    return _react2.default.createElement(
	        'header',
	        { id: 'header', style: props.timeout ? { display: 'none' } : {} },
	        _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	                'div',
	                { className: 'inner' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Michelle',
	                    Middot,
	                    'Tilley',
	                    Middot,
	                    'Photography'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Portraits and headshots for the San Francisco Bay Area'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#about' },
	                        'About'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#contact' },
	                        'Contact'
	                    )
	                )
	            )
	        )
	    );
	};
	
	Header.propTypes = {
	    onOpenArticle: _react2.default.PropTypes.func,
	    timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(75);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _pic = __webpack_require__(490);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(491);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _pic5 = __webpack_require__(492);
	
	var _pic6 = _interopRequireDefault(_pic5);
	
	var _avatar = __webpack_require__(488);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function stopPropagation(e) {
	  e.stopPropagation();
	}
	
	var Main = function (_React$Component) {
	  _inherits(Main, _React$Component);
	
	  function Main() {
	    _classCallCheck(this, Main);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Main.prototype.render = function render() {
	
	    var close = _react2.default.createElement('div', { className: 'close', onClick: function onClick() {
	        document.location.hash = "";
	      } });
	
	    var mainStyle = {
	      display: this.props.timeout ? 'flex' : 'none'
	    };
	
	    var stopProp = function stopProp(e) {
	      return e.stopPropagation;
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'main', style: mainStyle },
	      _react2.default.createElement(
	        'article',
	        { onClick: stopPropagation, id: 'intro', className: (this.props.article === 'intro' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'Intro'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image main' },
	          _react2.default.createElement('img', { src: _pic2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Aenean ornare velit lacus, ac varius enim ullamcorper eu. Proin aliquam facilisis ante interdum congue. Integer mollis, nisl amet convallis, porttitor magna ullamcorper, amet egestas mauris. Ut magna finibus nisi nec lacinia. Nam maximus erat id euismod egestas. By the way, check out my ',
	          _react2.default.createElement(
	            'a',
	            { href: '#work' },
	            'awesome work'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis dapibus rutrum facilisis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Etiam tristique libero eu nibh porttitor fermentum. Nullam venenatis erat id vehicula viverra. Nunc ultrices eros ut ultricies condimentum. Mauris risus lacus, blandit sit amet venenatis non, bibendum vitae dolor. Nunc lorem mauris, fringilla in aliquam at, euismod in lectus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. In non lorem sit amet elit placerat maximus. Pellentesque aliquam maximus risus, vel sed vehicula.'
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        'article',
	        { onClick: stopPropagation, id: 'work', className: (this.props.article === 'work' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'Work'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image main' },
	          _react2.default.createElement('img', { src: _pic4.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Adipiscing magna sed dolor elit. Praesent eleifend dignissim arcu, at eleifend sapien imperdiet ac. Aliquam erat volutpat. Praesent urna nisi, fringila lorem et vehicula lacinia quam. Integer sollicitudin mauris nec lorem luctus ultrices.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Nullam et orci eu lorem consequat tincidunt vivamus et sagittis libero. Mauris aliquet magna magna sed nunc rhoncus pharetra. Pellentesque condimentum sem. In efficitur ligula tate urna. Maecenas laoreet massa vel lacinia pellentesque lorem ipsum dolor. Nullam et orci eu lorem consequat tincidunt. Vivamus et sagittis libero. Mauris aliquet magna magna sed nunc rhoncus amet feugiat tempus.'
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        'article',
	        { onClick: stopPropagation, id: 'about', className: (this.props.article === 'about' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'About'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'image' },
	          _react2.default.createElement('img', { src: _avatar2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Hi, I\'m Michelle Tilley. I\'m a photograher based in Santa Clara, California. I work all over the San Francisco Bay Area. If you\'d like to work with me, ',
	          _react2.default.createElement(
	            'a',
	            { href: '#contact' },
	            'fill out my contact form'
	          ),
	          ' and I\'ll be in touch with you soon!'
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        'article',
	        { onClick: stopPropagation, id: 'contact', className: (this.props.article === 'contact' ? 'active' : '') + ' ' + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'major' },
	          'Contact'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I\'m excited to work with you! To start, please take a moment to tell me a little about your needs.'
	        ),
	        _react2.default.createElement('iframe', { id: 'taveForm', src: 'https://tave.com/michelle-tilley-photography-inline/', width: '100%', height: '1400px', frameBorder: '0', scrolling: 'yes', allowTransparency: 'true' }),
	        close
	      )
	    );
	  };
	
	  return Main;
	}(_react2.default.Component);
	
	Main.propTypes = {
	  route: _react2.default.PropTypes.object,
	  article: _react2.default.PropTypes.string,
	  articleTimeout: _react2.default.PropTypes.bool,
	  onCloseArticle: _react2.default.PropTypes.func,
	  timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bg.18c0da91.jpg";

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic01.55e1797f.jpg";

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(388);
	
	var _reactHelmet = __webpack_require__(56);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(217);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Main = __webpack_require__(218);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Footer = __webpack_require__(216);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _bg = __webpack_require__(489);
	
	var _bg2 = _interopRequireDefault(_bg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template(props) {
	    _classCallCheck(this, Template);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isArticleVisible: false,
	      timeout: false,
	      articleTimeout: false,
	      article: '',
	      loading: 'is-loading',
	      altBg: null
	    };
	
	    _this.onHashChange = _this.onHashChange.bind(_this);
	    _this.handleOpenArticle = _this.handleOpenArticle.bind(_this);
	    _this.handleCloseArticle = _this.handleCloseArticle.bind(_this);
	    _this.handleChangeArticle = _this.handleChangeArticle.bind(_this);
	    _this.handleBodyClick = _this.handleBodyClick.bind(_this);
	    return _this;
	  }
	
	  Template.prototype.handleBodyClick = function handleBodyClick() {
	    if (this.state.isArticleVisible) {
	      document.location.hash = '';
	    }
	  };
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.timeoutId = setTimeout(function () {
	      _this2.setState({ loading: '' });
	    }, 100);
	
	    this.secondTimeoutId = setTimeout(function () {
	      if (document.location.hash) {
	        _this2.handleOpenArticle(document.location.hash.replace(/^#/, ''));
	      }
	    }, 1000);
	
	    window.addEventListener('hashchange', this.onHashChange);
	
	    var img = new Image();
	    img.onload = function () {
	      console.log(img.src);
	      _this2.setState({ altBg: img.src });
	    };
	    img.src = _bg2.default;
	  };
	
	  Template.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.timeoutId) {
	      clearTimeout(this.timeoutId);
	    }
	    if (this.secondTimeoutId) {
	      clearTimeout(this.secondTimeoutId);
	    }
	
	    window.removeEventListener('hashchange', this.onHashChange);
	  };
	
	  Template.prototype.onHashChange = function onHashChange() {
	    var hash = document.location.hash.replace(/^#/, '');
	    if (hash) {
	      this.handleChangeArticle(hash);
	    } else {
	      this.handleCloseArticle();
	    }
	  };
	
	  Template.prototype.handleOpenArticle = function handleOpenArticle(article) {
	    var _this3 = this;
	
	    this.setState({
	      isArticleVisible: !this.state.isArticleVisible,
	      article: article
	    }, function () {
	      // document.location.hash = article;
	    });
	
	    setTimeout(function () {
	      _this3.setState({
	        timeout: !_this3.state.timeout
	      });
	    }, 325);
	
	    setTimeout(function () {
	      _this3.setState({
	        articleTimeout: !_this3.state.articleTimeout
	      });
	    }, 350);
	  };
	
	  Template.prototype.handleCloseArticle = function handleCloseArticle(callback) {
	    var _this4 = this;
	
	    if (this.state.isArticleVisible) {
	      this.setState({
	        articleTimeout: !this.state.articleTimeout
	      });
	
	      setTimeout(function () {
	        _this4.setState({
	          timeout: !_this4.state.timeout
	        });
	      }, 325);
	
	      setTimeout(function () {
	        _this4.setState({
	          isArticleVisible: !_this4.state.isArticleVisible,
	          article: ''
	        }, function () {
	          // document.location.hash = "";
	          if (callback) {
	            callback();
	          }
	        });
	      }, 350);
	    } else if (callback) {
	      callback();
	    }
	  };
	
	  Template.prototype.handleChangeArticle = function handleChangeArticle(newArticle) {
	    var _this5 = this;
	
	    this.handleCloseArticle(function () {
	      _this5.handleOpenArticle(newArticle);
	    });
	  };
	
	  Template.prototype.render = function render() {
	    var siteTitle = this.props.data.site.siteMetadata.title;
	    var siteDescription = this.props.data.site.siteMetadata.description;
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	
	    var rootPath = '/';
	
	    var content = void 0;
	
	    if (location.pathname === rootPath) {
	      content = _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        _react2.default.createElement(_Header2.default, { onOpenArticle: this.handleOpenArticle, timeout: this.state.timeout }),
	        _react2.default.createElement(_Main2.default, {
	          isArticleVisible: this.state.isArticleVisible,
	          timeout: this.state.timeout,
	          articleTimeout: this.state.articleTimeout,
	          article: this.state.article,
	          onCloseArticle: this.handleCloseArticle,
	          onChangeArticle: this.handleChangeArticle
	        }),
	        _react2.default.createElement(_Footer2.default, { timeout: this.state.timeout })
	      );
	    } else {
	      content = _react2.default.createElement(
	        'div',
	        { id: 'wrapper', className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { style: {
	              maxWidth: '1140px'
	            } },
	          children()
	        )
	      );
	    }
	
	    var bg = _react2.default.createElement('div', { id: 'bg' });
	    if (this.state.altBg) {
	      bg = _react2.default.createElement('div', { id: 'bg', style: { backgroundImage: 'url(' + this.state.altBg + ')' } });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'body ' + this.state.loading + ' ' + (this.state.isArticleVisible ? 'is-article-visible' : ''), onClick: this.handleBodyClick },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          siteTitle
	        ),
	        _react2.default.createElement('meta', { name: 'google-site-verification', content: 'qKuWqJYjwRXFSJzH5uoPqjjdFrBWflbZq-7HOWv31JE' }),
	        _react2.default.createElement('meta', { name: 'description', content: siteDescription }),
	        _react2.default.createElement('meta', { name: 'google-site-verification', content: 'u2OqGPw3zuIlM329WnNL5kDWkwF--xOfZHpFvpIBK9g' })
	      ),
	      content,
	      bg
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-59df09becc8376ba61c6.js